import { Button, Input, Tag, Popover } from "antd";
import TableFetchData from "../../components/data-table/TableFetchData";
import { useTranslation } from "react-i18next";
import SelectComponent from "../../components/select/SelectComponent";
import { formatDateTime } from "../../utils/dateFormatUtils";
import DateRangeComponent from "../../components/date/DateRangeComponent";
import AirlyPaySvg from "../../assets/images/AirlyPay";
import WeChatSvg from "../../assets/images/WeChat";
import SearchSvg from "../../assets/images/SearchSvg";

const TablePaymentSuper = ({ 
    loading, setLoading, paymentData,
    keyword, setKeyword,dates, setDates, initLoadPayment,
    dataObject, setDataObject, tableParams, setTableParams
}) => {
    const { t } = useTranslation();


    const tableSettings = {
        appendable: false,
        removable: false,
        bordered: true,
        size: "small",
        pagination: {
            showLessItems: true,
            showSizeChanger: false,
            pageSize: 10,
          },
        columns: [
            {
                title: <label className="titleCard14400">{t('Member ID')}</label>,
                render: (_, record) => (
                    <Popover
                        content={
                            <div style={{ padding: "4px 2px", minWidth: "180px", fontSize: "13px" }}>{console.log("record", record)}
                                <div style={{ marginBottom: "6px" }}>
                                    <span style={{ color: "#8c8c8c", marginRight: "6px" }}>{t("User's Name")}:</span>
                                    <span style={{ fontWeight: 500, color: "#262626" }}>{record?.member?.name || t("N/A")}</span>
                                </div>
                                <div style={{ marginBottom: "6px" }}>
                                    <span style={{ color: "#8c8c8c", marginRight: "6px" }}>{t("Phone Number")}:</span>
                                    <span style={{ fontWeight: 500, color: "#262626" }}>
                                        {record?.member?.phone?.countryCode && record?.member?.phone?.number
                                            ? `(${record.member.phone.countryCode}) ${record.member.phone.number}`
                                            : "N/A"}
                                    </span>
                                </div>
                                <div>
                                    <span style={{ color: "#8c8c8c", marginRight: "6px" }}>{t("Email Address")}:</span>
                                    <span style={{ fontWeight: 500, color: "#262626" }}>{record?.member?.email || t("N/A")}</span>
                                </div>
                            </div>
                        }
                        trigger="hover"
                    >
                        <label className="" style={{color:"#0d6efd", cursor: "pointer"}}>{record && record.member?.memberId}</label>
                    </Popover>
                ),
            },
            {
                title: <label className="titleCard14400">{t('Phone/Email')}</label>,
                render: (_, record) => {
                    const member = record?.member || record;
                    return (
                        <>
                            {record && record?.member && record?.member?.isDeleted ? (
                                <Tag color="error">Deleted</Tag>
                            ) : (
                                <div className="d-flex">
                                    <label className="">
                                        {member?.phone?.countryCode && member?.phone?.number
                                            ? `(${member.phone.countryCode}) ${member.phone.number}`
                                            : null}
                                        {member?.phone?.number && member?.email ? " / " : ""}
                                        {member?.email || ""}
                                    </label>
                                </div>
                            )}
                        </>
                    );
                },
            },
            // {
            //     title: t('Membership Years'),
            //     render: (_, record) => (
            //         <label className="text-capitalize">{"N/A"}</label>
            //     ),
            // },
            {
                title: <label className="titleCard14400">{t('Order Number')}</label>,
                render: (_, record) => (
                    <label className="text-capitalize">
                        {record && record.paymentId}
                    </label>
                ),
            },
            {
                title: <label className="titleCard14400">{t('Payment Amount')}</label>,
                render: (_, record) => (
                    <label className="text-capitalize">
                        {`￥${record && record.amount}`}
                    </label>
                ),
            },
            {
                title: <label className="ant-table-column-title titleCard14400">{t('Payment Time')}</label>,
                dataIndex: 'time',
                sorter: true,
                key: 'time',
                render: (_, record) => (
                    <>
                        {record.time ? formatDateTime(record.time) : ""}
                    </>
                )
            },
            {
                title: <label className="titleCard14400">{t('Payment Type')}</label>,
                render: (_, record) => (
                    <label className="text-capitalize">
                        {t(record && record.type)}
                    </label>
                ),
            },
            {
                title: <label className="titleCard14400">{t('Payment Portal')}</label>,
                render: (_, record) => {
                    if (record && record.method === 'alipay') {
                        return <AirlyPaySvg />;
                    } else if (record && record.method === 'wechatpay') {
                        return <WeChatSvg />;
                    } else {
                        return (
                            <label className="text-capitalize">
                                {t(record && record.method)} 
                            </label>
                        );
                    }
                },
            },
        ],
    };

    const paymentTypeOpt = [
        {
            label: t("activate"),
            value: "activate"
        },
        {
            label: t("renewal"),
            value: "renewal"
        },
        {
            label: t("upgrade"),
            value: "upgrade"
        }
    ]

    const paymentMethodOpt = [
        {
            label: t("alipay"),
            value: "alipay"
        },
        {
            label: t("wechatpay"),
            value: "wechatpay"
        },
        {
            label: t("bank"),
            value: "bank"
        },
        {
            label: t("card"),
            value: "card"
        },
        {
            label: t("manual"),
            value: "manual"
        }
    ]

    return (
        <>
            <div className="w-100" style={{ padding: "0px 25px" }}>
                <div className="d-flex justify-content-between mb-3">
                    <div className="d-flex align-items-center">
                        <Input
                            placeholder={t("Search")}
                            prefix={<SearchSvg style={{ color: '#8c8c8c' }} />}
                            size="large"
                            className='me-3 col-5'
                            disabled={loading}
                            loading={loading}
                            allowClear
                            value={keyword}
                            onChange={(e) => setKeyword(e.target.value)}
                        />
                        <DateRangeComponent
                            className="col-4 me-4"
                            placeholder={t("Please select a time or time period")}
                            disabled={loading}
                            value={dates ? dates : [null, null]}
                            setValue={setDates}
                            style={{ width: "25%" }}
                        />
                        <div className="me-4">
                            <SelectComponent
                                width="150px"
                                disabled={loading}
                                options={paymentTypeOpt}
                                value={dataObject.type}
                                setValue={(value) => setDataObject({ ...dataObject, type: value })}
                                placeholder={t('Payment Type')}
                            />
                        </div>
                        <div>
                            <SelectComponent
                                width="150px"
                                options={paymentMethodOpt}
                                value={dataObject.method}
                                setValue={(value) => setDataObject({ ...dataObject, method: value })}
                                placeholder={t("Payment Portal")}
                                disabled={loading}
                            />
                        </div>
                    </div>
                    <div>
                        <Button
                            size="large"
                            onClick={() => {
                                setTableParams({
                                    ...tableParams,
                                    pagination: {
                                        ...tableParams.pagination,
                                        current: 1,
                                    },
                                });
                                initLoadPayment();
                                // setIsSearch(false)
                                // setTimeout(() => {
                                //     setIsSearch(true)
                                // }, 100);
                            }}
                        >
                            {t('Query')}
                        </Button>

                    </div>
                </div>
            </div>
            <div className="w-100" style={{ padding: "0px 25px" }}>
                <TableFetchData
                    tableParams={tableParams}
                    setTableParams={setTableParams}
                    data={paymentData}
                    columns={tableSettings.columns}
                    loading={loading}
                    setLoading={setLoading}
                />
            </div>
        </>
    );
};

export default TablePaymentSuper;
